import { cqrs, setPathParameters } from '@faro/http-clients';
import { CommandResponse, RevisionedCommandResponse, Stage, toStage } from '@faro/study-designer-model';
import axios, { AxiosResponse } from 'axios';
import { StudyPathParameter } from '../parameter';

export interface StageQueryParameter {
    readonly schemaId?: string;
}

export type StagePathParameters = StudyPathParameter;
export type StageQueryParameters = StageQueryParameter;

/**
 * Client responsible for accessing the backend entity services
 */
export const stageClient = {
    ...cqrs<Stage, StagePathParameters>(
        '/api/study-designer/studies/:studyId/stages',
        toStage
    ).writableEntityClient<StageQueryParameters>(),

    createStage: cqrs<Stage & { sequenceNumber: number }, StagePathParameters>(
        '/api/study-designer/studies/:studyId/stages/actions/create',
        toStage as any
    ).create(),

    move: (moveCommand: Stage & { sequenceNumber: number }): Promise<RevisionedCommandResponse<CommandResponse>> =>
        axios
            .post<
                Stage & { sequenceNumber: number },
                AxiosResponse<RevisionedCommandResponse<CommandResponse>>
            >(setPathParameters('/api/study-designer/studies/:studyId/stages/:id/actions/move', moveCommand as any), { sequenceNumber: moveCommand.sequenceNumber })
            .then(response => response.data),

    reset: (resetCommand: Stage): Promise<RevisionedCommandResponse<CommandResponse>> =>
        axios
            .post<
                Stage & { sequenceNumber: number },
                AxiosResponse<RevisionedCommandResponse<CommandResponse>>
            >(setPathParameters('/api/study-designer/studies/:studyId/stages/:id/actions/reset', resetCommand as any), { target: 'soa' })
            .then(response => response.data),
};
